import { render, staticRenderFns } from "./PlanejamentoRoot.vue?vue&type=template&id=6436d5d8&"
import script from "./PlanejamentoRoot.vue?vue&type=script&lang=js&"
export * from "./PlanejamentoRoot.vue?vue&type=script&lang=js&"
import style0 from "./PlanejamentoRoot.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports